export default __webpack_public_path__ + "static/media/IncredibleAnimalsMigrators_01.b3c98bd3.png";